import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';

const InpatientSchema = Yup.object().shape({
    companyId: Yup.string()
        .required('Company is required.'),
    claimantId: Yup.string()
        .required('Claimant is required.'),
    // nationality: Yup.string()
    //     .required('Nationality is required.'),
    admissionDate: Yup.date()
        .required('Admission Date is required.'),
    dischargeDate: Yup.date()
        .required('Discharge Date is required.'),
    providerName: Yup.string()
        .required('Hospital is required.'),
    reasonForTreatment: Yup.string()
        .required('Reason For Treatment is required.'),
    nameOfOperation: Yup.string()
        .required('Name of Operation is required.'),
    accidentRelated: Yup.string()
        .required()
        .uppercase()
        .oneOf(['Y','N']),
    accidentDate: Yup.date()
        .when('accidentRelated', {
            is: 'Y',
            then: Yup.date().required('Date of Injury is required.'),
            otherwise: Yup.date()
        }),
    accidentTime: Yup.date()
        .when('accidentRelated', {
            is: 'Y',
            then: Yup.date().required('Time Of Injury is required.'),
            otherwise: Yup.date()
        }),
    workRelated: Yup.string()
        .when('accidentRelated', {
            is: 'Y',
            then: Yup.string().required().uppercase().oneOf(['Y','N']),
            otherwise: Yup.string()
        }),
    accidentDetails: Yup.string()
        .when('accidentRelated', {
            is: 'Y',
            then: Yup.string().required().lowercase(),
            otherwise: Yup.string()
        }),
    accidentClaimableFromCompany: Yup.string()
        .required()
        .uppercase()
        .oneOf(['Y','N']),
    claimingFromOtherInsurer: Yup.string()
        .required()
        .uppercase()
        .oneOf(['Y','N']),
    claimingFromOtherInsurerName: Yup.string()
        // .when(['accidentRelated','claimingFromOtherInsurer'], {
        .when('claimingFromOtherInsurer', {
            is: 'Y',
            then: Yup.string().required().uppercase(),
            otherwise: Yup.string()
        }),
    claimReferenceNo: Yup.string(),
    remarks: Yup.string().lowercase(),
    // payee: Yup.string()
    //     .required()
    //     .oneOf(['Employee','Employer']),
    // paymentMethod: Yup.string()
    //     .when('payee', {
    //         is: 'Employee',
    //         then: Yup.string().required().oneOf(['Bank','Cheque']),
    //         otherwise: Yup.string()
    //     }),
    // bankNo: Yup.string()
    //     .when(['payee', 'paymentMethod'], {
    //         is: (payee, paymentMethod) => payee === 'Employee' && paymentMethod === 'Bank',
    //         then: Yup.string().required().uppercase(),
    //         otherwise: Yup.string()
    //     }),
    // branchNo: Yup.string()
    //     .when(['payee', 'paymentMethod'], {
    //         is: (payee, paymentMethod) => payee === 'Employee' && paymentMethod === 'Bank',
    //         then: Yup.string().required().uppercase(),
    //         otherwise: Yup.string()
    //     }),
    // accountNo: Yup.string()
    //     .when(['payee', 'paymentMethod'], {
    //         is: (payee, paymentMethod) => payee === 'Employee' && paymentMethod === 'Bank',
    //         then: Yup.string().required().uppercase(),
    //         otherwise: Yup.string()
    //     }),
    amount: Yup.number()
        .required('Amount is required')
        .positive('Amount must be more than zero')
        .max(999999, 'Amount cannot be more than $999,999')
        .round(),
    currency: Yup.string()
        .required('Currency is required.'),
    symptoms: Yup.string()
        .required('Description Of Symptoms is required.'),
    symptomsStartDate: Yup.date()
        .required('Symptoms Start Date is required.'),
});

export default InpatientSchema;
